module.exports = __webpack_public_path__ + "img/background.a2bf2aad.png";